import { Stack, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import { Text } from "./Text";
import { Controller } from "react-hook-form";

type Props = {
  labels: string[];
  title: string;
  control: any;
  name: string;
};

export const FormRadioButtons = ({ labels, title, control, name }: Props) => {
  return (
    <Stack>
      <Stack
        direction="row"
        gap={1}
        alignItems="flex-end"
        paddingLeft={1}
        marginTop={3.5}
      >
        <Text fontWeight={700}>{title}</Text>
        <Text color="#7e0000" fontWeight={700} lineHeight={2.2} fontSize={12}>
          ＊
        </Text>
      </Stack>

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup
            {...field} // fieldをRadioGroupに渡すことで、選択状態をフォームに統合
            sx={{
              flexDirection: "row",
              marginTop: 1,
            }}
          >
            {labels.map((radio, index) => {
              return (
                <FormControlLabel
                  key={index}
                  value={index + 1}
                  control={<Radio />}
                  label={radio}
                />
              );
            })}
          </RadioGroup>
        )}
      />
    </Stack>
  );
};
